import './Settings.css'
import { useNavigate } from 'react-router-dom'
export default function Settings () {
    const navigate = useNavigate();
    return(
        <div className="popup">
            <button onClick={()=>navigate(-1)}>Go Back</button>
            <div className="popup__wrapper">
                <h2>Work in progress: . . .</h2>
                <br />
                <br />
                <div className="popup__wrapper-themeprev popup__wrapper-box">
                    <h2>Theme Preview:</h2>
                </div>
                <div className="popup__wrapper-theme popup__wrapper-box">
                    <h2>Mode:</h2>
                    <select name="" id="">
                        <option value="">Dark</option>
                        <option value="">Light</option>
                    </select>
                </div>
                <div className="popup__wrapper-theme-contrast popup__wrapper-box">
                    <h2>Accent Color:</h2>
                </div>
            </div>
        </div>
    )
}